var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconContact = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Frame"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M14.3354 7.99993C14.3354 11.4977 11.4999 14.3333 8.00208 14.3333C6.91668 14.3333 5.89502 14.0602 5.00208 13.5791C3.7566 12.9079 2.9185 13.5319 2.17936 13.6438C2.06724 13.6608 1.95558 13.6201 1.8754 13.5399C1.75369 13.4182 1.73052 13.23 1.79775 13.0715C2.08785 12.3878 2.35422 11.0921 1.99102 9.99993C1.78195 9.37127 1.66875 8.6988 1.66875 7.99993C1.66875 4.50213 4.50428 1.6666 8.00208 1.6666C11.4999 1.6666 14.3354 4.50213 14.3354 7.99993Z",
  stroke: "black",
  strokeWidth: 0.8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M8.08588 8.00006H8.00255M5.41875 8.00006H5.33542M10.7521 8.00006H10.6687M8.16922 8.00006C8.16922 8.09213 8.09462 8.16673 8.00255 8.16673C7.91055 8.16673 7.83588 8.09213 7.83588 8.00006C7.83588 7.908 7.91055 7.8334 8.00255 7.8334C8.09462 7.8334 8.16922 7.908 8.16922 8.00006ZM5.50208 8.00006C5.50208 8.09213 5.42746 8.16673 5.33542 8.16673C5.24337 8.16673 5.16875 8.09213 5.16875 8.00006C5.16875 7.908 5.24337 7.8334 5.33542 7.8334C5.42746 7.8334 5.50208 7.908 5.50208 8.00006ZM10.8354 8.00006C10.8354 8.09213 10.7608 8.16673 10.6687 8.16673C10.5767 8.16673 10.5021 8.09213 10.5021 8.00006C10.5021 7.908 10.5767 7.8334 10.6687 7.8334C10.7608 7.8334 10.8354 7.908 10.8354 8.00006Z",
  stroke: "black",
  strokeWidth: 0.8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconContact);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-contact.6cdd13a5fa596b328bdfd9ebe36633d5.svg";